import { UseStore } from 'zustand';
import { createUsePortfolioChartStore } from '@quantfoliorepo/ui-components';

export const usePortfolioChartStore: UseStore<any> =
  createUsePortfolioChartStore();
